/**
 * PDP variant-dependent regions via Shopify Section Rendering API.
 * Swap targets must match ids in snippets/pdp-variant-dependent.liquid wrappers.
 */
(function () {
  const PDP_VARIANT_REGIONS = [
    'pdp-variant-fields',
    'pdp-price',
    'pdp-delivery',
    'pdp-buttons',
  ];

  const pendingRequests = new Map();
  let deliveryBindingsReady = false;

  function getProductRoot(productEl) {
    if (productEl) return productEl;
    return document.getElementById('product-single');
  }

  function setRegionsLoading(sectionId, isLoading) {
    PDP_VARIANT_REGIONS.forEach(function (prefix) {
      const el = document.getElementById(prefix + '-' + sectionId);
      if (!el) return;
      el.classList.toggle('pdp-variant-region--loading', isLoading);
    });
  }

  function swapRegion(sectionId, prefix, sourceDoc) {
    const destId = prefix + '-' + sectionId;
    const source = sourceDoc.getElementById(destId);
    const dest = document.getElementById(destId);
    if (source && dest) {
      dest.innerHTML = source.innerHTML;
    }
  }

  function initPdpDeliveryBindings() {
    if (deliveryBindingsReady) return;
    deliveryBindingsReady = true;

    document.addEventListener('click', function (event) {
      const btn = event.target.closest('.change-delivery');
      if (!btn) return;

      document.querySelectorAll('.local-zip-error').forEach(function (el) {
        el.remove();
      });

      const zipInputs = document.querySelectorAll('.local-zip-code-val');
      const zipTextEl = document.querySelector('.change-delivery-option .live-zip-code');
      const zipValue = zipTextEl ? zipTextEl.textContent.trim() : '';

      zipInputs.forEach(function (input) {
        input.value = zipValue;
      });
    });
  }

  function initPdpPagePopups(productEl, attempt) {
    const $ = window.jQuery || window.$$;
    if (!$ || !$.fn || !$.fn.magnificPopup) {
      if ((attempt || 0) < 5) {
        setTimeout(function () {
          initPdpPagePopups(productEl, (attempt || 0) + 1);
        }, 200);
      }
      return;
    }

    productEl = getProductRoot(productEl);
    const sectionId = productEl && productEl.dataset.sectionId;
    if (!sectionId) return;

    const popupSelector = PDP_VARIANT_REGIONS.map(function (prefix) {
      return '#' + prefix + '-' + sectionId + ' [data-page-open-popup]';
    }).join(', ');

    const $popups = $(popupSelector);
    if (!$popups.length) return;

    $popups.each(function () {
      const $el = $(this);
      if ($el.data('magnificPopup')) {
        try {
          $el.magnificPopup('destroy');
        } catch (e) {
          $el.removeData('magnificPopup');
        }
      }
    });

    $popups.magnificPopup({
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = this.st.el.attr('data-effect');
        },
      },
      type: 'inline',
      removalDelay: 500,
      midClick: true,
    });
  }

  function loadPdpShippingBundle(productEl) {
    const deliveryRegion = productEl.querySelector('[id^="pdp-delivery-"]');
    if (!deliveryRegion) return;

    const freightEl = deliveryRegion.querySelector('.delivery-info[data-freight]');
    const isFreight = freightEl && freightEl.getAttribute('data-freight') === 'true';
    const scriptSrc = isFreight
      ? productEl.dataset.shippingFreightUrl
      : productEl.dataset.shippingNonFreightUrl;
    if (!scriptSrc) return;

    const scriptId = 'pdp-shipping-bundle';
    const existing = document.getElementById(scriptId);
    if (existing && existing.src === scriptSrc) return;

    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'module';
    script.src = scriptSrc;
    document.body.appendChild(script);
  }

  function applyMonthlyEmi(itemPrice) {
    if (typeof MonthlyEmiCalculator === 'undefined') return;

    const monthlyEmi = MonthlyEmiCalculator.calculateMonthlyEmi(itemPrice);

    if (monthlyEmi > 0) {
      document.querySelectorAll('.curacao-credit').forEach(function (el) {
        el.style.display = '';
      });
      document.querySelectorAll('.month-price').forEach(function (el) {
        el.innerHTML = '$' + monthlyEmi + '.00/mo*';
      });
      if (parseFloat(itemPrice) < 300) {
        document.querySelectorAll('.month-pay-set').forEach(function (el) {
          el.style.display = '';
        });
      }
      document.querySelectorAll('.month-price-card').forEach(function (el) {
        el.innerHTML = '$' + monthlyEmi + '.00';
      });
    } else {
      document.querySelectorAll('.month-pay-set').forEach(function (el) {
        el.remove();
      });
      document.querySelectorAll('.curacao-credit').forEach(function (el) {
        el.remove();
      });
    }
  }

  function updatePdpEmiFromVariant(variant) {
    if (!variant || variant.price == null) return;
    const itemPrice = (variant.price / 100).toFixed(2);
    applyMonthlyEmi(itemPrice);
  }

  function reapplyPdpZipDeliveryUi(productEl, zip) {
    const pdpZip = window.PdpZipDeliverability;
    if (!pdpZip || typeof pdpZip.reapplyPdpZipDeliveryState !== 'function') return;

    productEl = getProductRoot(productEl);
    pdpZip.reapplyPdpZipDeliveryState(productEl, zip);
  }

  function enablePdpAddToCartButtons(root) {
    root = getProductRoot(root) || document;
    root.querySelectorAll('[data-pdp-atc-pending]').forEach(function (el) {
      el.removeAttribute('data-pdp-atc-pending');
    });
  }

  function initPdpVariantUi(productEl, zip) {
    productEl = getProductRoot(productEl);
    if (!productEl) return;

    initPdpDeliveryBindings();
    loadPdpShippingBundle(productEl);
    reapplyPdpZipDeliveryUi(productEl, zip);

    if (
      window.Curacao &&
      window.Curacao.ZipCodeInput &&
      typeof window.Curacao.ZipCodeInput.init === 'function'
    ) {
      window.Curacao.ZipCodeInput.init(productEl);
    }

    const priceEl = productEl.querySelector('#js-product-price .item-price .money');
    if (priceEl) {
      const itemPrice = priceEl.textContent.substr(1).replace(/,/g, '').replace(/\$/g, '');
      applyMonthlyEmi(itemPrice);
    }

    document
      .querySelectorAll(
        '.template-product .details-info .cms-product-meta .group-button .js-btn-sold-out:not(.d-none-important)'
      )
      .forEach(function (button) {
        button.parentNode.classList.add('out_of-stock');
      });
  }

  async function renderPdpVariantSections(productEl, variantId) {
    productEl = getProductRoot(productEl);
    if (!productEl || !variantId) return;

    const productUrl = productEl.dataset.productUrl;
    const sectionId = productEl.dataset.sectionId;
    if (!productUrl || !sectionId) return;

    const requestKey = sectionId + ':' + variantId;
    if (pendingRequests.has(requestKey)) {
      pendingRequests.get(requestKey).abort();
    }

    const controller = new AbortController();
    pendingRequests.set(requestKey, controller);

    setRegionsLoading(sectionId, true);

    const pdpZip = window.PdpZipDeliverability;
    const savedZip =
      pdpZip && typeof pdpZip.getPdpCustomerZip === 'function'
        ? pdpZip.getPdpCustomerZip()
        : '';

    try {
      const fetchUrl =
        productUrl +
        '?variant=' +
        encodeURIComponent(variantId) +
        '&section_id=' +
        encodeURIComponent(sectionId);

      const response = await fetch(fetchUrl, { signal: controller.signal });
      if (!response.ok) throw new Error('Section render failed: ' + response.status);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      PDP_VARIANT_REGIONS.forEach(function (prefix) {
        swapRegion(sectionId, prefix, doc);
      });

      initPdpVariantUi(productEl, savedZip);
      initPdpPagePopups(productEl);

      document.body.dispatchEvent(
        new CustomEvent('afterVariantUpdated', {
          detail: { id: variantId },
        })
      );
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('PDP variant section render error:', error);
      }
    } finally {
      pendingRequests.delete(requestKey);
      setRegionsLoading(sectionId, false);
    }
  }

  const debouncedRender = (function () {
    let timer;
    function cancelDebouncedPdpVariantRender() {
      clearTimeout(timer);
      timer = null;
      pendingRequests.forEach(function (controller) {
        controller.abort();
      });
      pendingRequests.clear();
      document.querySelectorAll(".pdp-variant-region--loading").forEach(function (el) {
        el.classList.remove("pdp-variant-region--loading");
      });
    }
    function schedule(productEl, variantId) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        renderPdpVariantSections(productEl, variantId);
      }, 100);
    }
    schedule.cancel = cancelDebouncedPdpVariantRender;
    return schedule;
  })();

  window.renderPdpVariantSections = renderPdpVariantSections;
  window.debouncedRenderPdpVariantSections = debouncedRender;
  window.cancelDebouncedPdpVariantRender = debouncedRender.cancel;
  window.initPdpVariantUi = initPdpVariantUi;
  window.enablePdpAddToCartButtons = enablePdpAddToCartButtons;
  window.updatePdpEmiFromVariant = updatePdpEmiFromVariant;

  document.addEventListener('pdp:addToCartReady', function () {
    enablePdpAddToCartButtons();
  });

  window.addEventListener('load', function () {
    enablePdpAddToCartButtons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initPdpVariantUi();
  });
})();
